import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createContext } from 'react';
import { isTextField, getDocument } from 'ariakit-utils/dom';
import { createStoreContext } from 'ariakit-utils/store';
var NULL_ITEM = {
  id: null,
  ref: {
    current: null
  }
};

function getMaxRowLength(array) {
  var maxLength = 0;

  var _iterator = _createForOfIteratorHelper(array),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var length = _step.value.length;

      if (length > maxLength) {
        maxLength = length;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return maxLength;
}
/**
 * Returns only enabled items.
 */


function getEnabledItems(items, excludeId) {
  return items.filter(function (item) {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }

    return !item.disabled;
  });
}
/**
 * Finds the first enabled item.
 */


function findFirstEnabledItem(items, excludeId) {
  return items.find(function (item) {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }

    return !item.disabled;
  });
}
/**
 * Fills rows with fewer items with empty items so they all have the same
 * length.
 */


function normalizeRows(rows, activeId, focusShift) {
  var maxLength = getMaxRowLength(rows);

  var _iterator2 = _createForOfIteratorHelper(rows),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var row = _step2.value;

      for (var i = 0; i < maxLength; i += 1) {
        var item = row[i];

        if (!item || focusShift && item.disabled) {
          var isFirst = i === 0;
          var previousItem = isFirst && focusShift ? findFirstEnabledItem(row) : row[i - 1];
          row[i] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem(previousItem == null ? void 0 : previousItem.rowId);
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return rows;
}

function createEmptyItem(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    ref: {
      current: null
    },
    rowId: rowId
  };
}
/**
 * Finds the first enabled item by its id.
 */


function findEnabledItemById(items, id) {
  if (!id) return;
  return items.find(function (item) {
    return item.id === id && !item.disabled;
  });
}
/**
 * Gets the active id. If `passedId` is provided, it's going to take
 * precedence.
 */


function getActiveId(items, activeId, passedId) {
  var _findFirstEnabledItem;

  if (passedId !== undefined) {
    return passedId;
  }

  if (activeId !== undefined) {
    return activeId;
  }

  return (_findFirstEnabledItem = findFirstEnabledItem(items)) == null ? void 0 : _findFirstEnabledItem.id;
}
/**
 * Gets all items with the passed rowId.
 */


function getItemsInRow(items, rowId) {
  return items.filter(function (item) {
    return item.rowId === rowId;
  });
}
/**
 * Gets the opposite orientation.
 */


function getOppositeOrientation(orientation) {
  if (orientation === "vertical") return "horizontal";
  if (orientation === "horizontal") return "vertical";
  return;
}
/**
 * Creates a two-dimensional array with items grouped by their rowId's.
 */


function groupItemsByRows(items) {
  var rows = [];

  var _iterator3 = _createForOfIteratorHelper(items),
      _step3;

  try {
    var _loop = function _loop() {
      var item = _step3.value;
      var row = rows.find(function (currentRow) {
        var _currentRow$;

        return ((_currentRow$ = currentRow[0]) == null ? void 0 : _currentRow$.rowId) === item.rowId;
      });

      if (row) {
        row.push(item);
      } else {
        rows.push([item]);
      }
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return rows;
}
/**
 * Moves all the items before the passed `id` to the end of the array. This is
 * useful when we want to loop through the items in the same row or column as
 * the first items will be placed after the last items.
 *
 * The null item that's inserted when `shouldInsertNullItem` is set to `true`
 * represents the composite container itself. When the active item is null, the
 * composite container has focus.
 */


function flipItems(items, activeId, shouldInsertNullItem) {
  if (shouldInsertNullItem === void 0) {
    shouldInsertNullItem = false;
  }

  var index = items.findIndex(function (item) {
    return item.id === activeId;
  });
  return [].concat(_toConsumableArray(items.slice(index + 1)), _toConsumableArray(shouldInsertNullItem ? [NULL_ITEM] : []), _toConsumableArray(items.slice(0, index)));
}
/**
 * Changes the order of the items list so they are ordered vertically. That is,
 * if the active item is the first item in the first row, the next item will be
 * the first item in the second row, which is what you would expect when moving
 * up/down.
 */


function verticalizeItems(items) {
  var rows = groupItemsByRows(items);
  var maxLength = getMaxRowLength(rows);
  var verticalized = [];

  for (var i = 0; i < maxLength; i += 1) {
    var _iterator4 = _createForOfIteratorHelper(rows),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var row = _step4.value;
        var item = row[i];

        if (item) {
          verticalized.push(_objectSpread(_objectSpread({}, item), {}, {
            // If there's no rowId, it means that it's not a grid composite, but
            // a single row instead. So, instead of verticalizing it, that is,
            // assigning a different rowId based on the column index, we keep it
            // undefined so they will be part of the same row. This is useful
            // when using up/down on one-dimensional composites.
            rowId: item.rowId ? "" + i : undefined
          }));
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return verticalized;
}
/**
 * Gets item id.
 */


function getContextId(state, context) {
  return context != null && context.baseRef && context.baseRef === (state == null ? void 0 : state.baseRef) ? context.id : undefined;
}
/**
 * Selects text field contents even if it's a content editable element.
 */


function selectTextField(element, collapseToEnd) {
  if (collapseToEnd === void 0) {
    collapseToEnd = false;
  }

  if (isTextField(element)) {
    element.setSelectionRange(collapseToEnd ? element.value.length : 0, element.value.length);
  } else if (element.isContentEditable) {
    var selection = getDocument(element).getSelection();
    selection == null ? void 0 : selection.selectAllChildren(element);

    if (collapseToEnd) {
      selection == null ? void 0 : selection.collapseToEnd();
    }
  }
}

var FOCUS_SILENTLY = Symbol("FOCUS_SILENTLY");
/**
 * Focus an element with a flag. The `silentlyFocused` function needs to be
 * called later to check if the focus was silenced and to reset this state.
 */

function focusSilently(element) {
  element[FOCUS_SILENTLY] = true;
  element.focus();
}
/**
 * Checks whether the element has been focused with the `focusSilently` function
 * and resets the state.
 */


function silentlyFocused(element) {
  var isSilentlyFocused = element[FOCUS_SILENTLY];
  delete element[FOCUS_SILENTLY];
  return isSilentlyFocused;
}
/**
 * Determines whether the element is a composite item.
 */


function isItem(items, element, exclude) {
  if (!element) return false;
  return items.some(function (item) {
    if (exclude && item.ref.current === exclude) return false;
    return item.ref.current === element;
  });
}

var CompositeContext = createStoreContext();
var CompositeRowContext = /*#__PURE__*/createContext(undefined);
var CompositeItemContext = /*#__PURE__*/createContext(undefined);
export { CompositeContext as C, findFirstEnabledItem as a, getActiveId as b, getItemsInRow as c, getEnabledItems as d, flipItems as e, findEnabledItemById as f, groupItemsByRows as g, getOppositeOrientation as h, isItem as i, CompositeRowContext as j, getContextId as k, focusSilently as l, CompositeItemContext as m, normalizeRows as n, selectTextField as o, silentlyFocused as s, verticalizeItems as v };